import { useEffect, useState } from 'react';
import { throttle } from 'throttle-debounce-ts';

const useAutoLogOut = () => {
  const accessToken = localStorage.getItem('accessToken');
  const [loggedOut, setLoggedOut] = useState(false);

  const updateExpireTime = throttle(1000, () => {
    const hour = 1000 * 60 * 60;
    const expireTime = Date.now() + hour;

    localStorage.setItem('expireTime', expireTime.toString());
  });

  const checkForInactivity = () => {
    const expireTime = localStorage.getItem('expireTime');
    if (!expireTime)
      return updateExpireTime();

    if (Date.now() > parseInt(expireTime, 10) && !loggedOut) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('expireTime');
      setLoggedOut(true);
      window.location.href = '/login';
    }
  };

  useEffect(() => {
    if (!accessToken)
      return;

    const intervalId = setInterval(() => checkForInactivity(), 1000);
    return () => clearInterval(intervalId);
  }, [loggedOut, accessToken]);

  useEffect(() => {
    if (!accessToken)
      return;

    checkForInactivity();

    window.addEventListener('click', updateExpireTime);
    window.addEventListener('keypress', updateExpireTime);
    window.addEventListener('scroll', updateExpireTime);
    window.addEventListener('mousemove', updateExpireTime);

    return () => {
      window.removeEventListener('click', updateExpireTime);
      window.removeEventListener('keypress', updateExpireTime);
      window.removeEventListener('scroll', updateExpireTime);
      window.removeEventListener('mousemove', updateExpireTime);
    };
  }, [accessToken]);
};

export default useAutoLogOut;
